export default __webpack_public_path__ + "static/media/car-service-worker.13dcb4d1.jpg";